import AccountInfoSetting from "@/features/settings/components/account-info-setting";
import DeleteAccountSetting from "@/features/settings/components/delete-account-setting";
import LanguageSetting from "@/features/settings/components/language-setting";
import SecuritySetting from "@/features/settings/components/security-setting";

const SettingsPage = () => {
  return (
    <div className="p-6">
      <div className="max-w-md flex flex-col gap-8 pb-16">
        <AccountInfoSetting />
        <SecuritySetting />
        <LanguageSetting />
        <DeleteAccountSetting />
      </div>
    </div>
  );
};

export default SettingsPage;
